<template>
    <section>
        <div class="row">
            <div class="col-md-12 text-center">
                <h1><b>Billing Period: </b>{{$moment.parseZone(billingPeriod.start).local().format('DD/MM/YYYY')}}--{{$moment.parseZone(billingPeriod.end).local().format('DD/MM/YYYY')}}</h1>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-4">
                <div class="widget style1 navy-bg">
                    <div class="row">
                        <div class="col-xs-4">
                            <i class="fa fa-shopping-cart fa-5x"></i>
                        </div>
                        <div class="col-xs-8 text-right">
                            <span> Total Orders </span>
                            <h2 class="font-bold">{{billingStats.total_orders}}</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="widget style1 red-bg">
                    <div class="row">
                        <div class="col-xs-4">
                            <i class="fa fa-cart-arrow-down fa-5x"></i>
                        </div>
                        <div class="col-xs-8 text-right">
                            <span> Order Cancelled </span>
                            <h2 class="font-bold">{{billingStats.cancelled_order}}</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="widget style1 lazur-bg">
                    <div class="row">
                        <div class="col-xs-4">
                            <i class="fa fa-money fa-5x"></i>
                        </div>
                        <div class="col-xs-8 text-right">
                          <a @click="displayrestaurantCommissionDetailsPopUp()">
                            <span> Comission </span>
                            <h2 class="font-bold">{{(billingStats.commission) ? (billingStats.commission) : 0}}</h2>
                          </a>
                        </div>
                    </div>
                </div>
            </div>  
        </div>

        <div class="modal fade" id="restaurantCommissionDetailsPopUp" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Commission Earned Detail</h4>
              </div>
              <div class="modal-body row">
                <table class="table table-striped table-responsive table-bordered">
                  <thead>
                  <tr>
                    <th>Commission Per Order Charges</th>
                    <th>Orders Total Price Range</th>
                    <th>No of Orders</th>
                    <th>Total Commission</th>
                    <th>Total Price</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr style="white-space: nowrap" v-for="(resCommission, index) in restaurantCommissionDetails" v-bind:key="index+'_resCommission'">
                    <td>{{resCommission.profit}}</td>
                    <td>{{resCommission.profitConfig}}</td>
                    <td>{{resCommission.noOfOrders}}</td>
                    <td>{{parseFloat(resCommission.totalCommission).toFixed(2)}}</td>
                    <td>{{resCommission.totalPrice}}</td>
                  </tr>
                  <tr>
                    <td colspan="5" v-if="restaurantCommissionDetails.length === 0" style="text-align: left">No Profit Configuration.</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="modal-footer">
                <button type="button" @click="closerestaurantCommissionDetailsPopUp()" class="btn btn-default" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "CurrentBillingsStats",
        props:["billingStats", "billingPeriod", "selectedRestaurant"],
        data () {
            return {
              restaurantCommissionDetails: [],
            }
        },
      methods: {
        loadrestaurantCommissionDetailsPopUp: function (){
          let params = new URLSearchParams();
          params.append("start", this.billingPeriod.start+"");
          params.append("end", this.billingPeriod.end+"");
          params.append("restaurant_id", this.selectedRestaurant.id);
          if (this.selectedRestaurant.id > 0) {
            this.$http.get(this.$store.state.mainAppURL + "restaurants/get_commission_earned", {
              params: params
            }).then(commissionEarnedDetails => {
              this.restaurantCommissionDetails = commissionEarnedDetails.data;
            });
          }
        },
        displayrestaurantCommissionDetailsPopUp: function () {
          this.loadrestaurantCommissionDetailsPopUp();
          $("#restaurantCommissionDetailsPopUp").modal("show");
        },
        closerestaurantCommissionDetailsPopUp: function(){
          $("#restaurantCommissionDetailsPopUp").modal("hide");
        }
      }
    }
</script>

<style scoped>
a {
  color: #ffffff;
}
th, table{
  text-align: center;
}
</style>